module.exports = __webpack_public_path__ + "static/assets/61ea16007073ca9525361e32c94c72f4.svg";